/* Desayunos del Cielo · eventos de experiencia (GA4 + Google Ads via gtag de la app Google & YouTube).
   Solo observa clics/cambios; no altera el flujo de compra. Los eventos de ecommerce estándar
   (view_item, add_to_cart, begin_checkout, purchase…) los envía la app oficial: aquí NO se duplican. */
(function () {
  'use strict';
  if (window.__ddcEvents) return;
  window.__ddcEvents = true;

  var sentOnce = {};
  function send(name, params, onceKey) {
    if (onceKey) { if (sentOnce[onceKey]) return; sentOnce[onceKey] = true; }
    params = params || {};
    params.page_type = document.body && document.body.dataset && document.body.dataset.ddcTemplate || (location.pathname.split('/')[1] || 'home');
    try {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (_) {}
  }
  function txt(el) { return (el && (el.getAttribute('aria-label') || el.textContent) || '').replace(/\s+/g, ' ').trim().slice(0, 80); }
  function productName() {
    var h = document.querySelector('.product__title h1, h1');
    return location.pathname.indexOf('/products/') === 0 ? txt(h) : '';
  }
  function where(el) {
    var s = el.closest('[id^="shopify-section-"]');
    if (!s) return 'desconocido';
    return s.id.replace('shopify-section-', '').replace(/^template--\d+__/, '').replace(/_[A-Za-z0-9]+$/, '');
  }
  var cfgStarted = false;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t.closest && t.closest('a[href]');
    if (a) {
      var href = a.getAttribute('href') || '';
      if (/wa\.me|whatsapp\.com|api\.whatsapp/i.test(href)) {
        var waRef = '', waSrc = '';
        try { waRef = (JSON.parse(localStorage.getItem('ddc_wa_ref')) || {}).v || ''; waSrc = (JSON.parse(localStorage.getItem('ddc_first_src')) || {}).o || ''; } catch (_) {}
        send('whatsapp_click', {
          ubicacion: (a.dataset && a.dataset.waButton) || (a.closest('.ddc-wa-float, [data-ddc-whatsapp-float]') ? 'boton_flotante' : where(a)),
          texto: txt(a), producto: productName(), wa_ref: waRef, origen_trafico: waSrc
        });
        return;
      }
      if (/instagram\.com/i.test(href)) { send('ddc_social_click', { red: 'instagram', ubicacion: where(a) }); return; }
      if (/google\.[a-z.]+\/maps|g\.page|goo\.gl\/maps|search\.google\.com\/local/i.test(href)) { send('ddc_reviews_click', { ubicacion: where(a) }); return; }
      if (/^tel:/i.test(href)) { send('ddc_phone_click', { ubicacion: where(a) }); return; }
      if (/\/products\//.test(href) && !a.closest('.ddc-config')) {
        send('select_item', { item_list_name: where(a), items: [{ item_name: txt(a.querySelector('h3, .card__heading, [class*="title"]') || a) }] });
        return;
      }
      if (/\/collections\//.test(href)) { send('select_promotion', { promotion_name: where(a), creative_name: txt(a), destino: href.split('?')[0] }); return; }
    }
    var cfg = t.closest && t.closest('.ddc-config');
    if (cfg) {
      if (!cfgStarted) { cfgStarted = true; send('ddc_config_start', { producto: productName() }); }
      var edit = t.closest('[data-edit]');
      if (edit) send('ddc_review_edit', { seccion: edit.dataset.edit });
    }
    var reviewsNav = t.closest && t.closest('[data-ddc-reviews-nav] button');
    if (reviewsNav) send('ddc_reviews_browse', {}, 'reviews_browse');
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('.ddc-config')) return;
    if (!cfgStarted) { cfgStarted = true; send('ddc_config_start', { producto: productName() }); }
    var label = t.closest('label');
    if (t.matches('input[name="properties[Franja de entrega]"]')) {
      var special = t.hasAttribute('data-special') || /5:30/.test(t.value);
      send('ddc_slot_select', { franja: t.value, recargo: special ? 10000 : 0, producto: productName() });
    } else if (t.matches('[data-ddc-zone]')) {
      send('ddc_zone_select', { zona: t.value, producto: productName() });
    } else if (t.matches('[data-ddc-addon]')) {
      send(t.checked ? 'ddc_addon_add' : 'ddc_addon_remove', { adicional: txt(label) || t.value, producto: productName() });
    } else if (t.matches('[data-ddc-anonymous]')) {
      send('ddc_anon_toggle', { anonimo: t.checked ? 'si' : 'no' });
    } else if (t.matches('[data-ddc-color]')) {
      send('ddc_color_select', { color: t.value }, 'color_' + t.value);
    } else if (t.matches('[data-ddc-occasion]')) {
      send('ddc_occasion_select', { ocasion: t.value });
    }
  }, true);

  // Pasos y errores del configurador: se leen del DOM (data-active-step y mensajes de error visibles).
  function watchConfigurator(cfg) {
    var lastStep = cfg.dataset.activeStep || '1';
    new MutationObserver(function () {
      var s = cfg.dataset.activeStep;
      if (s && s !== lastStep) {
        if (Number(s) > Number(lastStep)) send('ddc_config_step', { paso: Number(lastStep), siguiente: Number(s), producto: productName() });
        lastStep = s;
        if (s === '3') send('ddc_checkout_ready', { producto: productName(), valor: totalValue(cfg) });
      }
    }).observe(cfg, { attributes: true, attributeFilter: ['data-active-step'] });
    cfg.querySelectorAll('[data-ddc-error], [data-ddc-color-error]').forEach(function (err) {
      new MutationObserver(function () {
        var visible = !err.hidden && txt(err);
        if (visible) send('ddc_config_error', { paso: Number(cfg.dataset.activeStep || 1), mensaje: txt(err).slice(0, 60) });
      }).observe(err, { attributes: true, childList: true, subtree: true, characterData: true });
    });
  }
  function totalValue(cfg) {
    var el = cfg.querySelector('[data-ddc-total]');
    var n = el ? Number((el.textContent || '').replace(/[^\d]/g, '')) : 0;
    return n || undefined;
  }

  // Videos, FAQ, reseñas visibles
  function onReady() {
    document.querySelectorAll('.ddc-config').forEach(watchConfigurator);
    document.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) send('ddc_faq_open', { pregunta: txt(d.querySelector('summary')), ubicacion: where(d) });
      });
    });
    document.querySelectorAll('video').forEach(function (v) {
      v.addEventListener('click', function () { send('ddc_video_click', { ubicacion: where(v) }); });
    });
    var reviews = document.querySelector('[data-ddc-reviews]');
    if (reviews && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (x) { return x.isIntersecting; })) { send('ddc_reviews_view', { ubicacion: where(reviews) }, 'reviews_view'); io.disconnect(); }
      }, { threshold: 0.4 });
      io.observe(reviews);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
